'use client'
import type { ReactNode } from 'react'
import { createContext, useContext, useEffect, useId, useRef, useState } from 'react'
import { cx } from '../utils'

export function Sheet({
  open,
  side = 'right',
  onClose,
  children,
}: {
  open: boolean
  side?: 'left' | 'right'
  onClose: () => void
  children: ReactNode
}) {
  useEffect(() => {
    if (!open) return
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && onClose()
    document.addEventListener('keydown', esc)
    return () => document.removeEventListener('keydown', esc)
  }, [open, onClose])
  if (!open) return null
  return (
    <div className="fixed inset-0 z-50 bg-ink/30 backdrop-blur-[2px]">
      <div className="absolute inset-0" onClick={onClose} aria-hidden />
      <div
        role="dialog"
        aria-modal
        className={cx(
          'fixed top-0 bottom-0 w-80 max-w-[90vw] bg-surface shadow-[var(--shadow-md)] border-line-strong',
          side === 'right' ? 'right-0 border-l' : 'left-0 border-r',
        )}
      >
        <div className="flex items-center justify-between border-b border-line px-5 py-4">
          <button
            onClick={onClose}
            aria-label="Close"
            className="pxs-focus grid h-6 w-6 place-items-center rounded-xs text-ink-3 hover:bg-sunken hover:text-ink"
          >
            <svg viewBox="0 0 10 10" className="h-2.5 w-2.5 fill-none stroke-current stroke-[1.5]">
              <path d="M1 1l8 8M9 1l-8 8" />
            </svg>
          </button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  )
}
